export type NotificationType =
  | 'chat'
  | 'participant_joined'
  | 'participant_left';
export type NotificationSoundType =
  | 'chat'
  | 'participant_joined'
  | 'participant_left';

export interface Config {
  notifications?: NotificationType[];
  notification_sounds?: NotificationSoundType[];
  videoFit?: string;
}
